module.exports = __webpack_public_path__ + "static/media/delete-item.4b262326.png";